<template>
  <div>
    <Button v-if="props.variant === 'default'" v-bind="attrs" class="logout-button" type="button" icon="pi pi-sign-out" :label="$t('topBar.logout')" @click="open = true" />
    <Button v-else v-bind="attrs" class="logout-menu-button" icon="pi pi-sign-out" :label="$t('topBar.logout')" @click="open = true" />

    <Dialog v-model:visible="open" header="Abmelden" :modal="true" :closable="!busy">
      <p>{{ $t('topBar.logoutDialog.confirmText') }}</p>
      <template #footer>
        <div style="display: flex; justify-content: space-around; width: 100%;">
          <Button class="logout-confirm-button" :label="$t('topBar.logoutDialog.confirmCta')" @click="confirm" :loading="busy" />
          <Button class="logout-cancle-button" :label="$t('topBar.logoutDialog.cancelCta')" @click="open = false" :disabled="busy" />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, useAttrs } from 'vue'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import { AuthApi } from '@/api/auth/auth'

defineOptions({
  inheritAttrs: false,
})

const open = ref(false)
const busy = ref(false)
const attrs = useAttrs()
const props = defineProps({
    variant: {type: String, default: 'default' }
});

const confirm = async () => {
    console.log("lets go logout")
    busy.value = true
    try {
        // Get Keycloak logout URL from backend (before clearing localStorage to ensure auth works)
        const response = await AuthApi.logout();

        // Clear local storage
        localStorage.clear();

        // Redirect to Keycloak logout - this will clear Keycloak session and redirect back
      console.log(response.logoutUrl)
        window.location.assign(response.logoutUrl)
    } catch (e) {
        console.log("error logging out", e)
        // Fallback: clear storage and redirect to home even if logout API fails
        localStorage.clear();
        window.location.assign('/')
    } finally {
        busy.value = false
        open.value = false
    }
}
</script>


<style scoped>
.logout-confirm-button {
    background-color: transparent;
    border: 1px solid var(--ghm-primary);
    color: var(--ghm-primary);
}

.logout-cancle-button {
    background-color: transparent !important;
    border: 1px solid var(--gray) !important;
    color: var(--gray) !important;
}

.logout-cancle-button:hover {
    background-color: var(--gray) !important;
    border: 1px solid var(--gray) !important;
    color: var(--white) !important;
}

.logout-cancle-button:active {
    background-color: var(--gray) !important;
    border: 1px solid var(--gray) !important;
    color: var(--white) !important;
}

.logout-button {
    background-color: transparent;
    border: 1px solid var(--ghm-primary);
    color: var(--ghm-primary);
}

.logout-button:active {
    background-color: var(--ghm-primary) !important;
    border: 1px solid var(--ghm-primary) !important;
}

.logout-confirm-button:active {
    background-color: var(--ghm-primary) !important;
    border: 1px solid var(--ghm-primary) !important;
}


.logout-button:focus-visible {
    outline: none;
}

.logout-menu-button {
background: none !important;
  border: none !important;
  padding: 0 !important;
  color: var(--ghm-primary);
}


.p-dialog-footer {
    justify-content: space-around !important;
}
</style>
